
import { Watch, Vue, Prop, Component } from "vue-property-decorator";
import { VIEW_PERMISSIONS } from "@/constant";

@Component
export default class ViewsSelectionComponent extends Vue {
  @Prop() public existingViews: any;
  public views = JSON.parse(JSON.stringify(VIEW_PERMISSIONS()));

  public mapViews(views) {
    this.views.forEach((v1) => {
      views.forEach((v2) => {
        if (v1.name === v2.name) {
          v1.access = v2.access;
          v1.readOnly = v2.readOnly;
          v1.viewParts.forEach((vp1) => {
            v2.viewParts.forEach((vp2) => {
              if (vp1.name === vp2.name) {
                vp1.access = vp2.access;
              }
            });
          });
        }
      });
    });
    this.updateSelection();
  }

  public updateSelection() {
    let filteredViews = this.filterSelectedViews();
    this.$emit("updateSelected", filteredViews);
  }

  public handleTopLevelPermission(index: number, prop: string, value: any) {
    /**
     * If ReadOnly is checked then assign deny value to each of the viewparts.
     */
    if (prop === "readOnly" && value) {
      this.views[index].access = "grant";
      this.views[index].viewParts.forEach((vp) => {
        vp.access = "deny";
      });
    } else {
      if (this.views[index].viewParts.length == 0) {
        this.views[index].access = value;
      }

      /**
       * The code below will assign values to its child level section
       * as per its state.
       * Eg : Granting the permission at a top level component
       * will grant to its sections as well.
       */
      this.views[index].readOnly = false;
      this.updateInheritedProperty(this.views[index].name, prop, value);
      this.views[index].viewParts.forEach((part) => {
        part[prop] = value;

        /**
         * Set the permission to those sections which are same as the current one.
         */
        this.updateInheritedProperty(part.name, prop, value);
      });
    }

    this.updateSelection();
  }

  public updateInheritedProperty(
    propName: string,
    prop: string,
    value: string
  ) {
    this.views.forEach((view) => {
      if (view.name === propName) {
        /**
         * Incase a viewpart is granted with permission then the readonly permission
         * will be set to false for that view
         */
        view.readOnly = false;
        /**
         * Update the main inherited section's
         * permission
         */
        view[prop] = value;
        view.viewParts.forEach((part) => {
          part[prop] = value;
        });
      }
      view.viewParts.forEach((vp) => {
        /**
         * Grant permission to the main screen if any
         * of the section has permission granted so
         * as to prevent the section from being overriden by
         * the permission `deny` again.
         */
        if (vp.access === "grant") {
          view.access = "grant";
        }

        /**
         * Update the related section permission
         */
        if (vp.name === propName) {
          if (view.access == "grant") {
            view.readOnly = false;
            vp[prop] = value;
          }
        }
      });

      /**
       * Set the top level screen to permission `deny`
       * if all the sections have permission denied.
       */
      if (
        view.viewParts.length > 0 &&
        view.viewParts.every((p) => p.access === "deny")
      ) {
        view.access = "deny";
      }
    });
    this.updateSelection();
  }

  public filterSelectedViews() {
    let views = new Array<any>();
    this.views.forEach((view, index) => {
      let v = { name: null, readOnly: false, access: null, viewParts: [] };
      if (view.access === "grant") {
        v.name = view.name;
        v.access = view.access;
        v.readOnly = view.readOnly;
        view.viewParts.forEach((vp) => {
          if (vp.access === "grant") {
            v.viewParts.push(vp);
          }
        });
      }
      if (v.name) {
        views.push(v);
      }
    });
    return views;
  }

  @Watch("existingViews")
  onChangeOfexistingViews(newViews) {
    this.views = JSON.parse(JSON.stringify(VIEW_PERMISSIONS()));
    if (newViews.length > 0) {
      this.mapViews(newViews);
    }
  }
  mounted() {
    this.views = JSON.parse(JSON.stringify(VIEW_PERMISSIONS()));
    if (this.existingViews && this.existingViews.length > 0) {
      this.mapViews(this.existingViews);
    }
  }
}
